/*
  Olavson Buy-Box-Paket (05.10.2026)

  Zwei Aufgaben auf der PDP:

  1. "Passend dazu" (snippets/buybox-complementary.liquid) und Set-Upgrade
     (snippets/buybox-set-upgrade.liquid) beim Absenden des Produktformulars.
     Ist nichts angehakt, greift dieses Script NICHT ein und der Impact-Submit
     (ProductForm in theme.js) laeuft unveraendert. Ist etwas angehakt, geht ein
     einziger /cart/add.js mit items[] raus: Hauptvariante (bzw. Set-Variante beim
     Upgrade) zuerst, danach die Haken. Erfolgsweg wie in theme.js und
     olv-gravur.js: gebuendelte Sections, variant:add, cart:change.

  2. Tausch einer 26er, die schon im Warenkorb liegt, gegen das Set (eigener
     Button). Reihenfolge: Set hinzufuegen, dann die Pfannenzeile per Line-Item-
     Key um 1 reduzieren. Schlaegt das Reduzieren fehl, wird das Set wieder
     entfernt, damit nie Pfanne und Set gleichzeitig liegen bleiben. Ein Set-
     Hinzufuegen zuerst haelt die Zwischensumme ueber der Geschenk-Schwelle, der
     Gift-Watcher nimmt das Geschenk dabei nicht kurz heraus.

  Warenkorb-Regeln fuer das Set-Angebot (gegen /cart.js):
   - Kein Angebot, wenn die Set-Variante oder die Zusatzgroesse (extraNums) schon
     im Warenkorb liegt, als Einzelpfanne desselben Produkts oder als Zeile des
     Set-Produkts.
   - Getauscht wird nur eine Zeile der gewaehlten Variante ohne Gravur-Token
     (_gravur) und ohne Geschenk-Kennung (_gift). Eine gravierte Pfanne wird nie
     getauscht.

  Solange etwas angehakt ist, setzt das Script data-olv-extras am Formular. Die
  CSS-Regel in snippets/buy-buttons.liquid blendet dann PayPal-Express und
  Ratenzahlungs-Hinweis gemeinsam aus: Der Express-Kauf submittet nur die
  angezeigte Variante und wuerde Haken und Set verlieren.

  Alle Requests laufen nacheinander. Gift- und Gravur-Watcher haengen sich selbst
  an /cart/* und laufen nach unseren Requests mit dem Endstand.
*/
(function () {
  if (window.__olavBuybox) return;
  window.__olavBuybox = 1;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JH = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function post(path, body) {
    return fetch(ROOT + path, { method: 'POST', headers: JH, body: JSON.stringify(body) }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (json) { return { ok: r.ok, json: json }; });
    });
  }

  function numsOf(title) {
    return String(title || '').replace(/[^0-9]+/g, ' ').trim().split(' ').filter(Boolean);
  }

  function isGift(line) {
    var p = line.properties || {};
    return !!(p._gift || p._lp_free_gift);
  }

  function isEngraved(line) {
    var p = line.properties || {};
    return !!p._gravur;
  }

  /* Effektive Hauptvariante wie beim Impact-Submit, inklusive Fallback-Tausch
     (snippets/fallback-variant.liquid schreibt die ID erst in seinem eigenen
     Capture-Handler um, der nach unserem laeuft). */
  function mainVariantId(form) {
    if (form.dataset.fallbackActive === '1' && form.dataset.fallbackTargetId) return form.dataset.fallbackTargetId;
    return form.id && form.id.value ? String(form.id.value) : '';
  }

  function upgradeFor(form) {
    return document.querySelector('olv-set-upgrade[form="' + form.getAttribute('id') + '"]');
  }

  /* Zaehlt nur Haken in einer sichtbaren Box. Mobil blendet sections/main-product.liquid
     Passend dazu per CSS aus; ein vorher am Desktop-Layout gesetzter Haken darf dann
     weder in den Warenkorb noch PayPal-Express ausblenden. */
  function checkedAddons(form) {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-olv-addon][data-olv-form="' + form.getAttribute('id') + '"]:checked')
    ).filter(function (box) {
      var bc = box.closest('.olv-bc');
      return !bc || bc.getClientRects().length > 0;
    });
  }

  function syncExtras(form) {
    if (!form) return;
    var up = upgradeFor(form);
    var active = checkedAddons(form).length > 0 || !!(up && up.upgradeTarget());
    if (active) form.dataset.olvExtras = '1';
    else delete form.dataset.olvExtras;
  }

  /* ---------------------------------------------------------- Set-Upgrade */

  var cartPromise = null;
  function sharedCart(fresh) {
    if (fresh || !cartPromise) cartPromise = getCart().catch(function () { return null; });
    return cartPromise;
  }

  class OlvSetUpgrade extends HTMLElement {
    connectedCallback() {
      var self = this;
      try {
        this._map = JSON.parse(this.querySelector('[data-olv-set-map]').textContent);
        this._texts = JSON.parse(this.querySelector('[data-olv-set-texts]').textContent);
      } catch (e) {
        this.hidden = true;
        return;
      }
      this._form = document.getElementById(this.getAttribute('form'));
      this._checkbox = this.querySelector('[data-olv-set-upgrade]');
      this._swapLine = null;
      this._busy = false;

      this._onChange = function () { syncExtras(self._form); };
      this._onSwap = function () { self.swap(); };
      this._onVariant = function () { self.evaluate(false); };
      this._onCart = function () { self.evaluate(true); };

      this._checkbox.addEventListener('change', this._onChange);
      this.querySelector('[data-olv-su-swap-button]').addEventListener('click', this._onSwap);
      if (this._form) this._form.addEventListener('variant:change', this._onVariant);
      document.addEventListener('cart:change', this._onCart);
      document.addEventListener('cart:refresh', this._onCart);

      this.evaluate(false);
    }

    disconnectedCallback() {
      if (this._form && this._onVariant) this._form.removeEventListener('variant:change', this._onVariant);
      if (this._onCart) {
        document.removeEventListener('cart:change', this._onCart);
        document.removeEventListener('cart:refresh', this._onCart);
      }
      /* Das ersetzte Element nimmt seinen Haken mit, das Formular soll das wissen. */
      var form = this._form;
      if (form) setTimeout(function () { syncExtras(form); }, 0);
    }

    entry() {
      if (!this._form || !this._map) return null;
      var id = String(this._form.id && this._form.id.value);
      if (this._map[id]) return this._map[id];
      /* snippets/fallback-variant.liquid schreibt beim Absenden die Eco-ID dauerhaft
         ins Formular. Danach steht dort die Fallback-ID statt der angezeigten
         Variante, der Eintrag wird ueber sie gefunden. */
      for (var k in this._map) {
        if (this._map.hasOwnProperty(k) && String(this._map[k].fallback) === id) return this._map[k];
      }
      return null;
    }

    /* Set-Variante, wenn der Haken fuer den naechsten Warenkorb-Klick gilt. */
    upgradeTarget() {
      var e = this.entry();
      if (!e || this.hidden || !this._checkbox || !this._checkbox.checked) return null;
      if (this.querySelector('[data-olv-su-offer]').hidden) return null;
      return String(e.set);
    }

    blocked(cart, e) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var ln = items[i];
        if (isGift(ln)) continue;
        if (String(ln.variant_id) === String(e.set)) return true;
        if (!e.extraNums || !e.extraNums.length) continue;
        var pid = String(ln.product_id);
      if (pid !== String(e.product) && pid !== String(e.setProduct) && pid !== String(e.fallbackProduct)) continue;
        var nums = numsOf(ln.variant_title);
        for (var j = 0; j < e.extraNums.length; j++) {
          if (nums.indexOf(String(e.extraNums[j])) >= 0) return true;
        }
      }
      return false;
    }

    /* Pfannenzeile der gewaehlten Variante, bei Eco-Tausch auch die der Fallback-Variante. */
    swappableLine(cart, variantId) {
      var e = this.entry();
      var ids = [String(variantId)];
      if (e && e.fallback) ids.push(String(e.fallback));
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var ln = items[i];
        if (ids.indexOf(String(ln.variant_id)) < 0) continue;
        if (isGift(ln) || isEngraved(ln)) continue;
        return ln;
      }
      return null;
    }

    evaluate(freshCart) {
      var self = this;
      var e = this.entry();

      if (!e || !e.setAvailable) {
        this.hidden = true;
        if (this._checkbox) this._checkbox.checked = false;
        syncExtras(this._form);
        return;
      }

      /* Liquid-Texte der gewaehlten Variante einsetzen, bevor der Warenkorb da ist. */
      this.querySelector('[data-olv-su-title]').textContent = e.offer;
      /* Zeile 2 traegt ein <strong> aus dem Locale-Key set_saving_html und kommt nur aus
         snippets/buybox-set-upgrade.liquid, deshalb innerHTML. Ohne Ersparnis ist sie aus. */
      var note = this.querySelector('[data-olv-su-note]');
      note.innerHTML = e.saving || '';
      note.hidden = !e.saving;
      this.querySelector('[data-olv-su-swap-text]').textContent = e.swap;

      var token = (this._evalToken = (this._evalToken || 0) + 1);
      sharedCart(freshCart).then(function (cart) {
        if (token !== self._evalToken) return;
        var offer = self.querySelector('[data-olv-su-offer]');
        var swap = self.querySelector('[data-olv-su-swap]');
        /* Die Tausch-Bestaetigung gilt nur, solange das Set noch im Warenkorb liegt
           (es kann z. B. im Drawer wieder entfernt werden). */
        if (self._doneSet && cart && !(cart.items || []).some(function (ln) { return String(ln.variant_id) === String(self._doneSet); })) {
          self._doneSet = null;
          self.message('');
        }
        /* Eine Meldung (z. B. nach dem Tausch) haelt das Element sichtbar, auch wenn kein Angebot mehr gilt. */
        var msgHidden = self.querySelector('[data-olv-su-message]').hidden;

        if (cart && self.blocked(cart, e)) {
          self.hidden = msgHidden;
          offer.hidden = true;
          swap.hidden = true;
          self._checkbox.checked = false;
          syncExtras(self._form);
          return;
        }

        self._swapLine = cart ? self.swappableLine(cart, String(self._form.id.value)) : null;

        if (self._swapLine) {
          offer.hidden = true;
          self._checkbox.checked = false;
          swap.hidden = false;
          self.hidden = false;
        } else {
          swap.hidden = true;
          offer.hidden = !e.available;
          self.hidden = !e.available && msgHidden;
          if (!e.available) self._checkbox.checked = false;
        }
        syncExtras(self._form);
      });
    }

    message(text) {
      var el = this.querySelector('[data-olv-su-message]');
      el.textContent = text || '';
      el.hidden = !text;
    }

    /* Tausch: Set dazu, dann genau eine ungravierte Pfannenzeile per Key um 1 runter.
       Rollback, wenn das Reduzieren scheitert. */
    swap() {
      var self = this;
      var e = this.entry();
      if (this._busy || !e) return;

      var button = this.querySelector('[data-olv-su-swap-button]');
      var variantId = String(this._form.id.value);
      this._busy = true;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      this.message('');

      var setLineBefore = 0;

      getCart().then(function (cart) {
        if (self.blocked(cart, e)) throw { soft: true };
        var line = self.swappableLine(cart, variantId);
        if (!line) throw { soft: true };

        (cart.items || []).forEach(function (ln) {
          if (String(ln.variant_id) === String(e.set) && !isGift(ln)) setLineBefore += ln.quantity;
        });

        return post('cart/add.js', { items: [{ id: Number(e.set), quantity: 1 }] }).then(function (res) {
          if (!res.ok) throw { message: (res.json && res.json.description) || self._texts.unavailable };
          return getCart();
        }).then(function (cart2) {
          /* Zeile nach dem Hinzufuegen frisch bestimmen: gleicher Key, wenn noch da,
             sonst erneut nach denselben Regeln (Bxgy kann Zeilen neu schluesseln). */
          var target = null;
          (cart2.items || []).forEach(function (ln) { if (!target && ln.key === line.key) target = ln; });
          if (!target) target = self.swappableLine(cart2, variantId);
          if (!target) return rollback(cart2);

          return post('cart/change.js', { id: target.key, quantity: target.quantity - 1 }).then(function (res) {
            if (!res.ok) return getCart().then(rollback);
          });
        });
      }).then(function (result) {
        if (result === 'rolled-back') {
          self.message(self._texts.error);
        } else {
          self._doneSet = e.set;
        self.message(e.done);
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') drawer.show();
        }
      }).catch(function (err) {
        if (!err || !err.soft) self.message((err && err.message) || self._texts.error);
      }).then(function () {
        self._busy = false;
        button.removeAttribute('aria-busy');
        button.disabled = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });

      function rollback(cartNow) {
        var setLine = null;
        (cartNow.items || []).forEach(function (ln) {
          if (!setLine && String(ln.variant_id) === String(e.set) && !isGift(ln)) setLine = ln;
        });
        var total = 0;
        (cartNow.items || []).forEach(function (ln) {
          if (String(ln.variant_id) === String(e.set) && !isGift(ln)) total += ln.quantity;
        });
        if (!setLine || total <= setLineBefore) return 'rolled-back';
        return post('cart/change.js', { id: setLine.key, quantity: setLine.quantity - 1 }).then(function () { return 'rolled-back'; });
      }
    }
  }

  if (!window.customElements.get('olv-set-upgrade')) {
    window.customElements.define('olv-set-upgrade', OlvSetUpgrade);
  }

  /* ------------------------------------------------- Passt-nur-zu-Filter */

  /* Blendet Zeilen mit data-olv-fit (Durchmesser aus custom.passt_zu_durchmesser)
     je nach gewaehlter Variante ein und aus. Die Karte Variante -> Durchmesser
     rendert snippets/buybox-complementary.liquid, auch fuer die Fallback-ID. Eine
     ausgeblendete Zeile verliert ihren Haken, sonst ginge sie unsichtbar mit in
     den Warenkorb. Ohne sichtbare Zeile verschwindet die ganze Box. */
  function syncFit(form) {
    if (!form) return;
    var box = document.querySelector('[data-olv-complementary][data-olv-form="' + form.getAttribute('id') + '"]');
    if (!box) return;
    var mapEl = box.querySelector('[data-olv-sizes]');
    if (!mapEl) return;
    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

    var sizes = map[String(form.id && form.id.value)] || [];
    var visible = 0;
    Array.prototype.forEach.call(box.querySelectorAll('.olv-bc__item'), function (li) {
      var fit = (li.getAttribute('data-olv-fit') || '').split(',').filter(Boolean);
      var show = !fit.length || fit.some(function (f) { return sizes.indexOf(f) >= 0; });
      li.hidden = !show;
      if (!show) {
        var box2 = li.querySelector('[data-olv-addon]');
        if (box2) box2.checked = false;
      } else {
        visible++;
      }
    });
    box.hidden = visible === 0;
    syncExtras(form);
  }

  document.addEventListener('variant:change', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form') : null;
    syncFit(form || event.target);
  });

  /* Anfangszustand kommt aus Liquid; einmal nachziehen, falls das Formular schon
     eine andere ID traegt (z. B. Zurueck-Navigation aus dem Cache). */
  Array.prototype.forEach.call(document.querySelectorAll('[data-olv-complementary][data-olv-form]'), function (box) {
    syncFit(document.getElementById(box.getAttribute('data-olv-form')));
  });

  /* Dreht ein Tablet ueber den Mobil-Breakpoint von sections/main-product.liquid und
     zurueck, wechselt die Sichtbarkeit der Box ohne change-Event. Dann Express-Status neu
     setzen. */
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var onBreakpoint = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-olv-complementary][data-olv-form]'), function (box) {
      syncExtras(document.getElementById(box.getAttribute('data-olv-form')));
    });
  };
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpoint);
  else if (mobileQuery.addListener) mobileQuery.addListener(onBreakpoint);

  /* ------------------------------------------------------------- Haken */

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.matches || !t.matches('[data-olv-addon]')) return;
    syncExtras(document.getElementById(t.getAttribute('data-olv-form')));
  });

  /* ------------------------------------------------------------- Submit */

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.getAttribute('is') !== 'product-form') return;

    var addons = checkedAddons(form).filter(function (box) {
      var li = box.closest('.olv-bc__item');
      return !(li && li.hidden);
    });
    var up = upgradeFor(form);
    var setId = up ? up.upgradeTarget() : null;
    if (!addons.length && !setId) return; /* Impact-Weg unveraendert */

    /* Ab hier uebernehmen wir: Impact-Handler und Fallback-Capture nicht mehr erreichen. */
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (form.__olvSubmitting) return;
    if (!form.checkValidity()) { form.reportValidity(); return; }

    var mainId = setId || mainVariantId(form);
    if (!mainId) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    var items = [{ id: Number(mainId), quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1 }];
    addons.forEach(function (box) { items.push({ id: Number(box.value), quantity: 1 }); });

    var submitButtons = Array.prototype.filter.call(form.elements, function (el) { return el.type === 'submit'; });
    submitButtons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    form.__olvSubmitting = true;

    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));

    post('cart/add.js', { items: items, sections: sections.join(','), sections_url: ROOT + 'variants/' + mainId })
      .then(function (res) {
        if (!res.ok) {
          form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: res.json && res.json.description } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        var tv = window.themeVariables && window.themeVariables.settings || {};
        if (tv.cartType === 'page' || tv.pageType === 'cart') {
          window.location.href = ROOT + 'cart';
          return;
        }

        return getCart().then(function (cart) {
          cart.sections = res.json.sections;

          addons.forEach(function (box) { box.checked = false; });
          if (up && up._checkbox) up._checkbox.checked = false;
          syncExtras(form);

          form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: res.json.items || [res.json], cart: cart }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cart }
          }));
        });
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .then(function () {
        form.__olvSubmitting = false;
        submitButtons.forEach(function (b) { b.removeAttribute('aria-busy'); });
      });
  }, true);
})();
